import React from "react";
import {isPrivateEmail} from "../../components/form/validators.jsx";
import common from "@well-b/well-b-shared";
import {PHONE_NUMBER_ERROR_VALIDATION} from "../../marketplace/consts.jsx";
import {systemPolicy} from "../../marketplace/Policy/consts.jsx";
import {AutoCompleteAddressFormInput} from "../../utils/AutoCompleteAddress.jsx";

export const REGISTER_FORM_FIELDS = (formValues, onAddressChange) => [
    {
        type: "multi",
        inputs: [
            {
                name: "name",
                type: "string",
                label: "שם החברה"
            },
            {
                name: "businessNumber",
                type: "number",
                label: "מס׳ ח.פ",
                rules: [
                    {
                        validator: (_, value) => {
                            const regexPattern = /^(5[0-9]|[6-8][0-9]|59)\d{7}$/;

                            if (value && !regexPattern.test(value)) {
                                return Promise.reject("מס' ח.פ אינו תקין: יש להזין מס' בן 9 ספרות");
                            } else {
                                return Promise.resolve();
                            }
                        }
                    }
                ]
            }
        ]
    },
    {
        type: "multi",
        inputs: [
            {
                name: "email",
                type: "email",
                label: "כתובת מייל ארגוני",
                rules: [
                    {
                        validator: (_, value) => {
                            if (isPrivateEmail(value)) {
                                return Promise.reject("אנא הכנס מייל חברה");
                            }

                            return Promise.resolve();
                        }
                    }
                ]
            },
            {
                name: "employeesCount",
                type: "number",
                label: "מס׳ עובדים משוער בארגון",
                rules: [
                    {
                        required: true
                    }
                ]
            }
        ]
    },
    {
        type: "multi",
        inputs: [
            {
                name: "address",
                type: "custom",
                label: "כתובת משרדית מלאה",
                placeholder: "הזינו כתובת החברה",
                info: "הזינו את כתובת המשרד שלכם כדי שנוכל להתאים עבורכם את התוכן",
                customComponent: (
                    <AutoCompleteAddressFormInput
                        allowSelectRegularText={false}
                        editValue={formValues?.address}
                        locationTypes={[]}
                        placeholder="הזן רחוב/ מס׳ בנין/ עיר"
                        countriesToSearchIn={["IL"]}
                        onChange={(_trimmedAddress, option) => {
                            onAddressChange(_trimmedAddress, {placeId: option?.place_id, address: _trimmedAddress});
                        }}
                    />
                )
            },
            {
                name: "floor",
                type: "number",
                label: "קומה",
                rules: [
                    {
                        validator: (_, value) => {
                            if (value <= 0) {
                                return Promise.reject("אנא הזינו קומה");
                            }
                            return Promise.resolve();
                        }
                    }
                ]
            }
        ]
    },
    {
        type: "multi",
        inputs: [
            {
                name: "contactName",
                type: "string",
                label: "שם מלא"
            },
            {
                name: "phone",
                type: "string",
                label: "מספר טלפון נייד",
                rules: [
                    {
                        validator: (_, value) => {
                            return value && !common.isValidPhoneMobileNumber(value)
                                ? Promise.reject(PHONE_NUMBER_ERROR_VALIDATION)
                                : Promise.resolve();
                        }
                    }
                ]
            }
        ]
    },
    {
        name: "policyConfirmed",
        type: "checkbox",
        checkboxText: systemPolicy
    }
];
